import { TableColumn } from '@leasequery/lq.react-component-library/dist/models';
import {
  ReportSnapshot,
  ReportSnapshotResultConfiguration,
} from '../../../../models';
import { toTitleCase } from '../../../../util';
import formatReportResultColumnAccessor from '../../../../util/formatReportResultColumnAccessor';
import ReportLeaseDescriptionColumn from '../ReportLeaseDescriptionColumn';
import ReportLeaseGeneralColumn from '../ReportLeaseGeneralColumn';
import { replaceIfrsLabels } from '../../../../util/frs102Helper';

const LEASE_DESCRIPTION_FIELD_NAME = 'leasedescription';
const SBITA_DESCRIPTION_FIELD_NAME = 'sbitadescription';

const createTableColumnFromConfig = (
  key: string,
  config: ReportSnapshotResultConfiguration,
  isFrs102Enabled: boolean,
): TableColumn => {
  const headerName = config.displayName || toTitleCase(key);
  const displayedName = replaceIfrsLabels(headerName, isFrs102Enabled);
  const isLeaseDescriptionColumn =
    key.toLowerCase().replace(' ', '') === LEASE_DESCRIPTION_FIELD_NAME || key.toLowerCase().replace(' ', '') === SBITA_DESCRIPTION_FIELD_NAME; 
  const formattedKey = formatReportResultColumnAccessor(key);
  return {
    id: formattedKey,
    Header: displayedName,
    Cell: isLeaseDescriptionColumn
      ? ReportLeaseDescriptionColumn
      : ReportLeaseGeneralColumn,
    width: isLeaseDescriptionColumn ? '32vw' : undefined,
    sticky: isLeaseDescriptionColumn && config.order === 1,
    accessor: formattedKey,
  };
};

const buildTableColumnsFromSnapshot = (
  reportSnapshot: ReportSnapshot,
  isFrs102Enabled: boolean,
): TableColumn[] => {
  const { resultConfiguration, results } = reportSnapshot;
  if (!results || !results.length) return null;

  const columnEntries = Object.entries(resultConfiguration).sort(
    ([, val1], [, val2]) => val1.order - val2.order,
  );

  // grouping columns
  const groups = columnEntries.reduce((acc, [key, config]) => {
    const groupName = config.groupName || '';
    let group = acc.get(groupName);

    if (!group) {
      group = {
        id: groupName,
        Header: groupName,
        accessor: '',
        columns: [],
      };
      acc.set(groupName, group);
    }
    const col = createTableColumnFromConfig(key, config, isFrs102Enabled);
    group.columns.push(col);
    return acc;
  }, new Map<string, TableColumn>());

  // flattern non-group columns
  const columns = [];
  groups.forEach((group, key) => {
    if (key === '') {
      columns.push(...group.columns);
    } else {
      columns.push(group);
    }
  });

  return columns;
};

export { buildTableColumnsFromSnapshot, LEASE_DESCRIPTION_FIELD_NAME };
